import { jsx as _jsx } from "react/jsx-runtime";
import ExpandDownIcon from "@diligentcorp/atlas-react-icons/ExpandDown.js";
const getAccordionTokens = (tokens) => {
    return {
        accordion: tokens.component.accordion,
        iconSize: tokens.semantic.iconSize,
        shadow: tokens.semantic.shadow,
    };
};
const accordion = (tokens) => {
    const { accordion, iconSize, shadow } = getAccordionTokens(tokens);
    return {
        MuiAccordion: {
            defaultProps: {
                disableGutters: true,
                square: true,
                elevation: 0,
            },
            styleOverrides: {
                root: {
                    paddingLeft: 0,
                    paddingRight: 0,
                    borderBottom: `${accordion.borderBottomWidth.value} solid ${accordion.borderBottomColor.value}`,
                    "& .MuiListItemButton-root:hover": {
                        backgroundColor: "initial",
                        color: "initial",
                    },
                    "&.Mui-disabled": {
                        backgroundColor: "initial",
                    },
                    "&:last-child": {
                        borderBottom: 0,
                    },
                    "&:before": {
                        display: "none",
                    },
                },
            },
        },
        MuiAccordionSummary: {
            defaultProps: {
                expandIcon: _jsx(ExpandDownIcon, {}),
                "data-atlas-alignment": "start",
            },
            styleOverrides: {
                root: {
                    gap: accordion.gap.value,
                    padding: `${accordion.paddingVertical.value} ${accordion.paddingHorizontal.value}`,
                    backgroundColor: accordion.backgroundColor.value,
                    // default align to left
                    flexDirection: "row-reverse",
                    ".MuiAccordionSummary-expandIconWrapper": {
                        color: accordion.icon.color.value,
                        fontSize: iconSize.lg.value,
                        svg: {
                            width: iconSize.lg.value,
                            height: iconSize.lg.value,
                        },
                        transform: "rotate(-90deg)",
                        "&.Mui-expanded": {
                            transform: "rotate(0deg)",
                        },
                    },
                    ".MuiAccordionSummary-content": {
                        margin: 0,
                        color: accordion.color.value,
                        fontSize: accordion.fontSize.value,
                        fontWeight: accordion.fontWeight.value,
                        lineHeight: accordion.lineHeight.value,
                    },
                    "&.Mui-disabled .MuiAccordionSummary-content": {
                        color: accordion.disabled.color.value,
                    },
                    "&.Mui-disabled": {
                        opacity: 1,
                    },
                    "&.Mui-disabled .MuiAccordionSummary-expandIconWrapper": {
                        color: accordion.disabled.color.value,
                    },
                    "&:focus, &.Mui-focusVisible": {
                        boxShadow: shadow.focusInset.value.stringValue,
                    },
                    "&:hover": {
                        backgroundColor: accordion.hover.backgroundColor.value,
                    },
                    "&:active": {
                        backgroundColor: accordion.active.backgroundColor.value,
                    },
                    // align to right
                    "[data-atlas-alignment='end'] &": {
                        flexDirection: "row",
                        ".MuiAccordionSummary-content": {
                            justifyContent: "flex-end",
                        },
                    },
                },
            },
        },
        MuiAccordionDetails: {
            styleOverrides: {
                root: {
                    paddingLeft: accordion.content.paddingHorizontal.value,
                    paddingRight: accordion.content.paddingHorizontal.value,
                    paddingTop: accordion.content.paddingVertical.value,
                    paddingBottom: accordion.content.paddingVertical.value,
                },
            },
        },
    };
};
export default accordion;
//# sourceMappingURL=accordion.js.map